import { useMutation } from '@tanstack/react-query';
import APIClient from '@/services/APIClient';
import BaseServices from '@/services/BaseServices';
import { UpdateSeatStatusPayload } from '@/apiModels/SeatStatusPayload';

const useUpdateSeatStatus = ({
  cb,
  cbError,
  cbSuccess,
}: IMutationHookProps<UpdateSeatStatusPayload>) => {
  return useMutation<
    UpdateSeatStatusPayload,
    CustomError<RevelErrorResponse>,
    UpdateSeatReservationRequest<UpdateSeatStatusPayload>
  >({
    mutationFn: ({ payload, eventId, seatId }) => {
      const apiClient = new APIClient<UpdateSeatStatusPayload>(
        BaseServices.SEAT_RESERVATION_SERVICE,
        `/user-app/admin/seat/${seatId}/event/${eventId}/update-seat-status`,
      );
      return apiClient.update<UpdateSeatStatusPayload>(payload);
    },
    onSuccess: cbSuccess,
    onError: cbError,
    onMutate: cb,
  });
};

export default useUpdateSeatStatus;
